// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.12.0 (commit 2f8905d6aaf3e9ffcbce3a8a1a1e30e715ad5db7).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcceptInviteReducer from "./accept_invite_reducer";
import AddCommentReducer from "./add_comment_reducer";
import AddLinkCommentReducer from "./add_link_comment_reducer";
import AdminCancelJobReducer from "./admin_cancel_job_reducer";
import AdminDeleteOrgReducer from "./admin_delete_org_reducer";
import AdminDeleteUserReducer from "./admin_delete_user_reducer";
import AdminDeleteWorkerReducer from "./admin_delete_worker_reducer";
import AdminPurgeTrashReducer from "./admin_purge_trash_reducer";
import AdminPurgeTrashManyReducer from "./admin_purge_trash_many_reducer";
import AdminRequestWorkerUpdateReducer from "./admin_request_worker_update_reducer";
import AdminRequeueJobReducer from "./admin_requeue_job_reducer";
import AdminRestoreTrashReducer from "./admin_restore_trash_reducer";
import AdminRestoreTrashManyReducer from "./admin_restore_trash_many_reducer";
import AdminSetOrgInvoicingReducer from "./admin_set_org_invoicing_reducer";
import AdminSetOrgPlanReducer from "./admin_set_org_plan_reducer";
import AdminSetOrgStorageLimitReducer from "./admin_set_org_storage_limit_reducer";
import AdminSetOrgSuspendedReducer from "./admin_set_org_suspended_reducer";
import AdminSetSuperadminReducer from "./admin_set_superadmin_reducer";
import AdminSetUserSuspendedReducer from "./admin_set_user_suspended_reducer";
import AdminSetWorkerDisabledReducer from "./admin_set_worker_disabled_reducer";
import AdminSetWorkerScalingReducer from "./admin_set_worker_scaling_reducer";
import ApplyEditsReducer from "./apply_edits_reducer";
import CancelJobReducer from "./cancel_job_reducer";
import CancelReplaceAssetReducer from "./cancel_replace_asset_reducer";
import CancelReviewReducer from "./cancel_review_reducer";
import CancelUploadReducer from "./cancel_upload_reducer";
import CreateAnimationPresetReducer from "./create_animation_preset_reducer";
import CreateAssetReducer from "./create_asset_reducer";
import CreateAssetReviewLinkReducer from "./create_asset_review_link_reducer";
import CreateColorPaletteReducer from "./create_color_palette_reducer";
import CreateFolderReducer from "./create_folder_reducer";
import CreateFromTemplateReducer from "./create_from_template_reducer";
import CreateGroupReducer from "./create_group_reducer";
import CreateInviteReducer from "./create_invite_reducer";
import CreateOrgReducer from "./create_org_reducer";
import CreateProjectReducer from "./create_project_reducer";
import CreateProjectFolderReducer from "./create_project_folder_reducer";
import CreateReviewLinkReducer from "./create_review_link_reducer";
import CreateSnapshotReducer from "./create_snapshot_reducer";
import CreateSpaceReducer from "./create_space_reducer";
import DeclineInviteReducer from "./decline_invite_reducer";
import DeleteAnimationPresetReducer from "./delete_animation_preset_reducer";
import DeleteAssetReducer from "./delete_asset_reducer";
import DeleteColorPaletteReducer from "./delete_color_palette_reducer";
import DeleteCommentReducer from "./delete_comment_reducer";
import DeleteFolderReducer from "./delete_folder_reducer";
import DeleteGroupReducer from "./delete_group_reducer";
import DeleteIntegrationReducer from "./delete_integration_reducer";
import DeleteJobReducer from "./delete_job_reducer";
import DeleteMcpKeyReducer from "./delete_mcp_key_reducer";
import DeleteMotionTrackReducer from "./delete_motion_track_reducer";
import DeleteNotificationsReducer from "./delete_notifications_reducer";
import DeleteOrgReducer from "./delete_org_reducer";
import DeleteProjectReducer from "./delete_project_reducer";
import DeleteProjectFolderReducer from "./delete_project_folder_reducer";
import DeleteReviewLinkReducer from "./delete_review_link_reducer";
import DeleteSnapshotReducer from "./delete_snapshot_reducer";
import DeleteSpaceReducer from "./delete_space_reducer";
import DeleteStorageSourceReducer from "./delete_storage_source_reducer";
import DuplicateProjectReducer from "./duplicate_project_reducer";
import DuplicateVersionReducer from "./duplicate_version_reducer";
import EditCommentReducer from "./edit_comment_reducer";
import ImportFromSourceReducer from "./import_from_source_reducer";
import InviteToTargetReducer from "./invite_to_target_reducer";
import LeaveOrgReducer from "./leave_org_reducer";
import LockClipsReducer from "./lock_clips_reducer";
import MarkAllNotificationsReadReducer from "./mark_all_notifications_read_reducer";
import MarkNotificationsReadReducer from "./mark_notifications_read_reducer";
import MoveAssetsReducer from "./move_assets_reducer";
import MoveFolderReducer from "./move_folder_reducer";
import MoveProjectReducer from "./move_project_reducer";
import MoveProjectFolderReducer from "./move_project_folder_reducer";
import OrgDeleteWorkerReducer from "./org_delete_worker_reducer";
import OrgRenameWorkerReducer from "./org_rename_worker_reducer";
import OrgRequestWorkerUpdateReducer from "./org_request_worker_update_reducer";
import OrgSetWorkerDisabledReducer from "./org_set_worker_disabled_reducer";
import PresenceEnterReducer from "./presence_enter_reducer";
import PresenceLeaveReducer from "./presence_leave_reducer";
import PresenceUpdateReducer from "./presence_update_reducer";
import RemoveMemberReducer from "./remove_member_reducer";
import RenameAnimationPresetReducer from "./rename_animation_preset_reducer";
import RenameFolderReducer from "./rename_folder_reducer";
import RenameJobReducer from "./rename_job_reducer";
import RenameMcpKeyReducer from "./rename_mcp_key_reducer";
import RenameOrgReducer from "./rename_org_reducer";
import RenameProjectFolderReducer from "./rename_project_folder_reducer";
import ReplaceAssetReducer from "./replace_asset_reducer";
import ReprocessAssetReducer from "./reprocess_asset_reducer";
import RequestAnalysisReducer from "./request_analysis_reducer";
import RequestBatchExportReducer from "./request_batch_export_reducer";
import RequestConvertReducer from "./request_convert_reducer";
import RequestExportReducer from "./request_export_reducer";
import RequestInvoicingReducer from "./request_invoicing_reducer";
import RequestMotionTrackReducer from "./request_motion_track_reducer";
import RequestPreviewReducer from "./request_preview_reducer";
import RequestReviewReducer from "./request_review_reducer";
import RequestSplitExportReducer from "./request_split_export_reducer";
import RequestStillReducer from "./request_still_reducer";
import RequestVoiceoverReducer from "./request_voiceover_reducer";
import ResendInviteReducer from "./resend_invite_reducer";
import ResolveCommentReducer from "./resolve_comment_reducer";
import RestoreSnapshotReducer from "./restore_snapshot_reducer";
import RetryJobReducer from "./retry_job_reducer";
import RevokeInviteReducer from "./revoke_invite_reducer";
import SetAssetReviewRoundReducer from "./set_asset_review_round_reducer";
import SetGrantReducer from "./set_grant_reducer";
import SetGroupMemberReducer from "./set_group_member_reducer";
import SetMemberRoleReducer from "./set_member_role_reducer";
import SetNotificationPrefsReducer from "./set_notification_prefs_reducer";
import SetOrgLogoReducer from "./set_org_logo_reducer";
import SetProjectColorSpaceReducer from "./set_project_color_space_reducer";
import SetProjectLogoReducer from "./set_project_logo_reducer";
import SetProjectTemplateReducer from "./set_project_template_reducer";
import SetProjectWatchReducer from "./set_project_watch_reducer";
import SetProjectWorkingSpaceReducer from "./set_project_working_space_reducer";
import SetRestrictedReducer from "./set_restricted_reducer";
import SetReviewLinkExpiryReducer from "./set_review_link_expiry_reducer";
import SetReviewLinkVersionReducer from "./set_review_link_version_reducer";
import SetSyncLeaderReducer from "./set_sync_leader_reducer";
import ShareVersionReducer from "./share_version_reducer";
import SubmitAssetReviewReducer from "./submit_asset_review_reducer";
import SubmitReviewReducer from "./submit_review_reducer";
import SvcAddRenderPackReducer from "./svc_add_render_pack_reducer";
import SvcAssetUploadedReducer from "./svc_asset_uploaded_reducer";
import SvcAuditReducer from "./svc_audit_reducer";
import SvcCancelUploadReducer from "./svc_cancel_upload_reducer";
import SvcConsumeMagicLinkReducer from "./svc_consume_magic_link_reducer";
import SvcCreateMagicLinkReducer from "./svc_create_magic_link_reducer";
import SvcCreateMcpKeyReducer from "./svc_create_mcp_key_reducer";
import SvcCreateOrgWorkerReducer from "./svc_create_org_worker_reducer";
import SvcCreateSessionReducer from "./svc_create_session_reducer";
import SvcCreateWorkerReducer from "./svc_create_worker_reducer";
import SvcDeleteSessionReducer from "./svc_delete_session_reducer";
import SvcEmailFailedReducer from "./svc_email_failed_reducer";
import SvcEmailSentReducer from "./svc_email_sent_reducer";
import SvcGcDoneReducer from "./svc_gc_done_reducer";
import SvcGcFailedReducer from "./svc_gc_failed_reducer";
import SvcIntegrationSentReducer from "./svc_integration_sent_reducer";
import SvcMarkLinkedMissingReducer from "./svc_mark_linked_missing_reducer";
import SvcReplacementUploadedReducer from "./svc_replacement_uploaded_reducer";
import SvcReprocessAssetReducer from "./svc_reprocess_asset_reducer";
import SvcRequestSourceCheckReducer from "./svc_request_source_check_reducer";
import SvcRequestSourceListingReducer from "./svc_request_source_listing_reducer";
import SvcReviewCommentReducer from "./svc_review_comment_reducer";
import SvcReviewDecisionReducer from "./svc_review_decision_reducer";
import SvcSaveIntegrationReducer from "./svc_save_integration_reducer";
import SvcSaveStorageSourceReducer from "./svc_save_storage_source_reducer";
import SvcSetModuleBuildReducer from "./svc_set_module_build_reducer";
import SvcSetOrgBillingReducer from "./svc_set_org_billing_reducer";
import SvcSetReviewLinkPasswordReducer from "./svc_set_review_link_password_reducer";
import SvcSetSourceErrorReducer from "./svc_set_source_error_reducer";
import SvcSetStripeCustomerReducer from "./svc_set_stripe_customer_reducer";
import SvcSourceAuditReducer from "./svc_source_audit_reducer";
import SvcTouchMcpKeyReducer from "./svc_touch_mcp_key_reducer";
import SvcTouchSessionReducer from "./svc_touch_session_reducer";
import SvcUnsubscribeEmailReducer from "./svc_unsubscribe_email_reducer";
import SvcUpgradeIntegrationsReducer from "./svc_upgrade_integrations_reducer";
import SvcUpsertUserReducer from "./svc_upsert_user_reducer";
import SvcWorkerScalingStatusReducer from "./svc_worker_scaling_status_reducer";
import UpdateAssetReducer from "./update_asset_reducer";
import UpdateColorPaletteReducer from "./update_color_palette_reducer";
import UpdateGroupReducer from "./update_group_reducer";
import UpdateProfileReducer from "./update_profile_reducer";
import UpdateProjectReducer from "./update_project_reducer";
import UpdateReviewLinkReducer from "./update_review_link_reducer";
import UpdateSpaceReducer from "./update_space_reducer";
import WorkerClaimReducer from "./worker_claim_reducer";
import WorkerCompleteAnalysisReducer from "./worker_complete_analysis_reducer";
import WorkerCompleteMediaReducer from "./worker_complete_media_reducer";
import WorkerCompleteRenderReducer from "./worker_complete_render_reducer";
import WorkerCompleteTrackReducer from "./worker_complete_track_reducer";
import WorkerFailReducer from "./worker_fail_reducer";
import WorkerHeartbeatReducer from "./worker_heartbeat_reducer";
import WorkerHelloReducer from "./worker_hello_reducer";
import WorkerLinkedMissingReducer from "./worker_linked_missing_reducer";
import WorkerProgressReducer from "./worker_progress_reducer";
import WorkerSetSourceRootsReducer from "./worker_set_source_roots_reducer";
import WorkerSourceListedReducer from "./worker_source_listed_reducer";
import WorkerUpdateResultReducer from "./worker_update_result_reducer";
import WorkerVoiceoverUploadedReducer from "./worker_voiceover_uploaded_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AccessRow from "./access_table";
import AccessGrantRow from "./access_grant_table";
import AccountRow from "./account_table";
import AdminAuditRow from "./admin_audit_table";
import AdminJobsRow from "./admin_jobs_table";
import AdminMembersRow from "./admin_members_table";
import AdminOrgsRow from "./admin_orgs_table";
import AdminStatsRow from "./admin_stats_table";
import AdminTrashRow from "./admin_trash_table";
import AdminUsersRow from "./admin_users_table";
import AdminWorkerScalingRow from "./admin_worker_scaling_table";
import AdminWorkersRow from "./admin_workers_table";
import AnimationPresetRow from "./animation_preset_table";
import AssetRow from "./asset_table";
import AssetAnalysisRow from "./asset_analysis_table";
import AssetFolderRow from "./asset_folder_table";
import AssetReviewRow from "./asset_review_table";
import AssetShareRow from "./asset_share_table";
import AssetViewerRow from "./asset_viewer_table";
import ClipRow from "./clip_table";
import ColorPaletteRow from "./color_palette_table";
import CommentRow from "./comment_table";
import GroupMemberRow from "./group_member_table";
import IntegrationRow from "./integration_table";
import JobRow from "./job_table";
import JobPayloadRow from "./job_payload_table";
import LogoRow from "./logo_table";
import MarkerRow from "./marker_table";
import MotionTrackRow from "./motion_track_table";
import MyMcpKeysRow from "./my_mcp_keys_table";
import NotificationRow from "./notification_table";
import NotificationSettingsRow from "./notification_settings_table";
import OrgRow from "./org_table";
import OrgInviteRow from "./org_invite_table";
import OrgMemberRow from "./org_member_table";
import OrgUsageRow from "./org_usage_table";
import OrgWorkerChoicesRow from "./org_worker_choices_table";
import OrgWorkersRow from "./org_workers_table";
import PresenceRow from "./presence_table";
import ProjectRow from "./project_table";
import ProjectAssetRow from "./project_asset_table";
import ProjectFolderRow from "./project_folder_table";
import ProjectSnapshotRow from "./project_snapshot_table";
import ProjectWatchRow from "./project_watch_table";
import ReviewDecisionRow from "./review_decision_table";
import ReviewLinkRow from "./review_link_table";
import ScopeAccessRow from "./scope_access_table";
import SourceRequestRow from "./source_request_table";
import SpaceRow from "./space_table";
import StorageSourceRow from "./storage_source_table";
import TrackRow from "./track_table";
import UserGroupRow from "./user_group_table";
import WorkerAccessRow from "./worker_access_table";
import WorkerPoolsRow from "./worker_pools_table";
import WorkerSelfRow from "./worker_self_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  access: __table({
    name: 'access',
    indexes: [
      { accessor: 'id', name: 'access_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity', name: 'access_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'orgId', name: 'access_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'access_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AccessRow),
  accessGrant: __table({
    name: 'access_grant',
    indexes: [
      { accessor: 'id', name: 'access_grant_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'access_grant_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'principalId', name: 'access_grant_principal_id_idx_btree', algorithm: 'btree', columns: [
        'principalId',
      ] },
      { accessor: 'targetId', name: 'access_grant_target_id_idx_btree', algorithm: 'btree', columns: [
        'targetId',
      ] },
    ],
    constraints: [
      { name: 'access_grant_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AccessGrantRow),
  account: __table({
    name: 'account',
    indexes: [
      { accessor: 'email', name: 'account_email_idx_btree', algorithm: 'btree', columns: [
        'email',
      ] },
      { accessor: 'identity', name: 'account_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'userId', name: 'account_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'account_identity_key', constraint: 'unique', columns: ['identity'] },
      { name: 'account_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, AccountRow),
  animationPreset: __table({
    name: 'animation_preset',
    indexes: [
      { accessor: 'id', name: 'animation_preset_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'animation_preset_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'animation_preset_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AnimationPresetRow),
  asset: __table({
    name: 'asset',
    indexes: [
      { accessor: 'id', name: 'asset_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'asset_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'asset_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'status', name: 'asset_status_idx_btree', algorithm: 'btree', columns: [
        'status',
      ] },
    ],
    constraints: [
      { name: 'asset_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AssetRow),
  assetAnalysis: __table({
    name: 'asset_analysis',
    indexes: [
      { accessor: 'assetId', name: 'asset_analysis_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'id', name: 'asset_analysis_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'asset_analysis_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'asset_analysis_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'asset_analysis_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AssetAnalysisRow),
  assetFolder: __table({
    name: 'asset_folder',
    indexes: [
      { accessor: 'id', name: 'asset_folder_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'asset_folder_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'asset_folder_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'asset_folder_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AssetFolderRow),
  assetReview: __table({
    name: 'asset_review',
    indexes: [
      { accessor: 'assetId', name: 'asset_review_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'orgId', name: 'asset_review_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'asset_review_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'asset_review_asset_id_key', constraint: 'unique', columns: ['assetId'] },
    ],
  }, AssetReviewRow),
  assetShare: __table({
    name: 'asset_share',
    indexes: [
      { accessor: 'assetId', name: 'asset_share_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'id', name: 'asset_share_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'asset_share_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'asset_share_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'asset_share_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'asset_share_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AssetShareRow),
  assetViewer: __table({
    name: 'asset_viewer',
    indexes: [
      { accessor: 'assetId', name: 'asset_viewer_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'id', name: 'asset_viewer_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity', name: 'asset_viewer_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'orgId', name: 'asset_viewer_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'asset_viewer_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AssetViewerRow),
  clip: __table({
    name: 'clip',
    indexes: [
      { accessor: 'id', name: 'clip_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'clip_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'clip_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'clip_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'trackId', name: 'clip_track_id_idx_btree', algorithm: 'btree', columns: [
        'trackId',
      ] },
    ],
    constraints: [
      { name: 'clip_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ClipRow),
  colorPalette: __table({
    name: 'color_palette',
    indexes: [
      { accessor: 'id', name: 'color_palette_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'color_palette_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'color_palette_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ColorPaletteRow),
  comment: __table({
    name: 'comment',
    indexes: [
      { accessor: 'id', name: 'comment_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'linkId', name: 'comment_link_id_idx_btree', algorithm: 'btree', columns: [
        'linkId',
      ] },
      { accessor: 'orgId', name: 'comment_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'comment_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'comment_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'comment_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CommentRow),
  groupMember: __table({
    name: 'group_member',
    indexes: [
      { accessor: 'groupId', name: 'group_member_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'id', name: 'group_member_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'group_member_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'userId', name: 'group_member_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'group_member_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GroupMemberRow),
  job: __table({
    name: 'job',
    indexes: [
      { accessor: 'id', name: 'job_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'job_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'parentId', name: 'job_parent_id_idx_btree', algorithm: 'btree', columns: [
        'parentId',
      ] },
      { accessor: 'pool', name: 'job_pool_idx_btree', algorithm: 'btree', columns: [
        'pool',
      ] },
      { accessor: 'scopeId', name: 'job_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'status', name: 'job_status_idx_btree', algorithm: 'btree', columns: [
        'status',
      ] },
    ],
    constraints: [
      { name: 'job_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, JobRow),
  jobPayload: __table({
    name: 'job_payload',
    indexes: [
      { accessor: 'jobId', name: 'job_payload_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'pool', name: 'job_payload_pool_idx_btree', algorithm: 'btree', columns: [
        'pool',
      ] },
    ],
    constraints: [
      { name: 'job_payload_job_id_key', constraint: 'unique', columns: ['jobId'] },
    ],
  }, JobPayloadRow),
  logo: __table({
    name: 'logo',
    indexes: [
      { accessor: 'id', name: 'logo_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'logo_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'logo_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'logo_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LogoRow),
  marker: __table({
    name: 'marker',
    indexes: [
      { accessor: 'id', name: 'marker_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'marker_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'marker_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'marker_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'marker_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MarkerRow),
  motionTrack: __table({
    name: 'motion_track',
    indexes: [
      { accessor: 'id', name: 'motion_track_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'motion_track_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'motion_track_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'motion_track_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'motion_track_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MotionTrackRow),
  notification: __table({
    name: 'notification',
    indexes: [
      { accessor: 'assetId', name: 'notification_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'emailStatus', name: 'notification_email_status_idx_btree', algorithm: 'btree', columns: [
        'emailStatus',
      ] },
      { accessor: 'id', name: 'notification_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'notification_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'notification_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'userId', name: 'notification_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'notification_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, NotificationRow),
  notificationSettings: __table({
    name: 'notification_settings',
    indexes: [
      { accessor: 'userId', name: 'notification_settings_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'notification_settings_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, NotificationSettingsRow),
  org: __table({
    name: 'org',
    indexes: [
      { accessor: 'id', name: 'org_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'slug', name: 'org_slug_idx_btree', algorithm: 'btree', columns: [
        'slug',
      ] },
    ],
    constraints: [
      { name: 'org_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'org_slug_key', constraint: 'unique', columns: ['slug'] },
    ],
  }, OrgRow),
  orgInvite: __table({
    name: 'org_invite',
    indexes: [
      { accessor: 'email', name: 'org_invite_email_idx_btree', algorithm: 'btree', columns: [
        'email',
      ] },
      { accessor: 'id', name: 'org_invite_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'org_invite_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'org_invite_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgInviteRow),
  orgMember: __table({
    name: 'org_member',
    indexes: [
      { accessor: 'id', name: 'org_member_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'org_member_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'byOrgUser', name: 'org_member_org_id_user_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
        'userId',
      ] },
      { accessor: 'userId', name: 'org_member_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'org_member_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgMemberRow),
  orgUsage: __table({
    name: 'org_usage',
    indexes: [
      { accessor: 'id', name: 'org_usage_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'org_usage_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'org_usage_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgUsageRow),
  presence: __table({
    name: 'presence',
    indexes: [
      { accessor: 'connectionId', name: 'presence_connection_id_idx_btree', algorithm: 'btree', columns: [
        'connectionId',
      ] },
      { accessor: 'identity', name: 'presence_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'orgId', name: 'presence_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'presence_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'presence_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'presence_connection_id_key', constraint: 'unique', columns: ['connectionId'] },
    ],
  }, PresenceRow),
  project: __table({
    name: 'project',
    indexes: [
      { accessor: 'id', name: 'project_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'project_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'project_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'spaceId', name: 'project_space_id_idx_btree', algorithm: 'btree', columns: [
        'spaceId',
      ] },
    ],
    constraints: [
      { name: 'project_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectRow),
  projectAsset: __table({
    name: 'project_asset',
    indexes: [
      { accessor: 'assetId', name: 'project_asset_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'id', name: 'project_asset_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'project_asset_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'project_asset_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'project_asset_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'project_asset_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectAssetRow),
  projectFolder: __table({
    name: 'project_folder',
    indexes: [
      { accessor: 'id', name: 'project_folder_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'project_folder_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'project_folder_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'spaceId', name: 'project_folder_space_id_idx_btree', algorithm: 'btree', columns: [
        'spaceId',
      ] },
    ],
    constraints: [
      { name: 'project_folder_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectFolderRow),
  projectSnapshot: __table({
    name: 'project_snapshot',
    indexes: [
      { accessor: 'id', name: 'project_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'project_snapshot_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'project_snapshot_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'project_snapshot_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'project_snapshot_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectSnapshotRow),
  projectWatch: __table({
    name: 'project_watch',
    indexes: [
      { accessor: 'id', name: 'project_watch_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'project_watch_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'project_watch_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'userId', name: 'project_watch_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'project_watch_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectWatchRow),
  reviewDecision: __table({
    name: 'review_decision',
    indexes: [
      { accessor: 'assetId', name: 'review_decision_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'id', name: 'review_decision_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'review_decision_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'review_decision_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'review_decision_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'review_decision_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ReviewDecisionRow),
  reviewLink: __table({
    name: 'review_link',
    indexes: [
      { accessor: 'id', name: 'review_link_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'review_link_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'review_link_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'review_link_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'token', name: 'review_link_token_idx_btree', algorithm: 'btree', columns: [
        'token',
      ] },
    ],
    constraints: [
      { name: 'review_link_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'review_link_token_key', constraint: 'unique', columns: ['token'] },
    ],
  }, ReviewLinkRow),
  scopeAccess: __table({
    name: 'scope_access',
    indexes: [
      { accessor: 'id', name: 'scope_access_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity', name: 'scope_access_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'orgId', name: 'scope_access_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'scope_access_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
      { accessor: 'userId', name: 'scope_access_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'scope_access_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ScopeAccessRow),
  integration: __table({
    name: 'somehub_connection',
    indexes: [
      { accessor: 'id', name: 'somehub_connection_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'somehub_connection_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'somehub_connection_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, IntegrationRow),
  sourceRequest: __table({
    name: 'source_request',
    indexes: [
      { accessor: 'id', name: 'source_request_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'workerId', name: 'source_request_worker_id_idx_btree', algorithm: 'btree', columns: [
        'workerId',
      ] },
    ],
    constraints: [
      { name: 'source_request_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, SourceRequestRow),
  space: __table({
    name: 'space',
    indexes: [
      { accessor: 'id', name: 'space_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'space_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'space_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'space_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, SpaceRow),
  storageSource: __table({
    name: 'storage_source',
    indexes: [
      { accessor: 'id', name: 'storage_source_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'storage_source_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'scopeId', name: 'storage_source_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'storage_source_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, StorageSourceRow),
  track: __table({
    name: 'track',
    indexes: [
      { accessor: 'id', name: 'track_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'track_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'projectId', name: 'track_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scopeId', name: 'track_scope_id_idx_btree', algorithm: 'btree', columns: [
        'scopeId',
      ] },
    ],
    constraints: [
      { name: 'track_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TrackRow),
  userGroup: __table({
    name: 'user_group',
    indexes: [
      { accessor: 'id', name: 'user_group_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'orgId', name: 'user_group_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'user_group_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserGroupRow),
  workerAccess: __table({
    name: 'worker_access',
    indexes: [
      { accessor: 'id', name: 'worker_access_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity', name: 'worker_access_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'pool', name: 'worker_access_pool_idx_btree', algorithm: 'btree', columns: [
        'pool',
      ] },
      { accessor: 'workerId', name: 'worker_access_worker_id_idx_btree', algorithm: 'btree', columns: [
        'workerId',
      ] },
    ],
    constraints: [
      { name: 'worker_access_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorkerAccessRow),
  adminAudit: __table({
    name: 'admin_audit',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminAuditRow),
  adminJobs: __table({
    name: 'admin_jobs',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminJobsRow),
  adminMembers: __table({
    name: 'admin_members',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminMembersRow),
  adminOrgs: __table({
    name: 'admin_orgs',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminOrgsRow),
  adminStats: __table({
    name: 'admin_stats',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminStatsRow),
  adminTrash: __table({
    name: 'admin_trash',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminTrashRow),
  adminUsers: __table({
    name: 'admin_users',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminUsersRow),
  adminWorkerScaling: __table({
    name: 'admin_worker_scaling',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminWorkerScalingRow),
  adminWorkers: __table({
    name: 'admin_workers',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminWorkersRow),
  myMcpKeys: __table({
    name: 'my_mcp_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMcpKeysRow),
  orgWorkerChoices: __table({
    name: 'org_worker_choices',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgWorkerChoicesRow),
  orgWorkers: __table({
    name: 'org_workers',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgWorkersRow),
  workerPools: __table({
    name: 'worker_pools',
    indexes: [
    ],
    constraints: [
    ],
  }, WorkerPoolsRow),
  workerSelf: __table({
    name: 'worker_self',
    indexes: [
    ],
    constraints: [
    ],
  }, WorkerSelfRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("accept_invite", AcceptInviteReducer),
  __reducerSchema("add_comment", AddCommentReducer),
  __reducerSchema("add_link_comment", AddLinkCommentReducer),
  __reducerSchema("admin_cancel_job", AdminCancelJobReducer),
  __reducerSchema("admin_delete_org", AdminDeleteOrgReducer),
  __reducerSchema("admin_delete_user", AdminDeleteUserReducer),
  __reducerSchema("admin_delete_worker", AdminDeleteWorkerReducer),
  __reducerSchema("admin_purge_trash", AdminPurgeTrashReducer),
  __reducerSchema("admin_purge_trash_many", AdminPurgeTrashManyReducer),
  __reducerSchema("admin_request_worker_update", AdminRequestWorkerUpdateReducer),
  __reducerSchema("admin_requeue_job", AdminRequeueJobReducer),
  __reducerSchema("admin_restore_trash", AdminRestoreTrashReducer),
  __reducerSchema("admin_restore_trash_many", AdminRestoreTrashManyReducer),
  __reducerSchema("admin_set_org_invoicing", AdminSetOrgInvoicingReducer),
  __reducerSchema("admin_set_org_plan", AdminSetOrgPlanReducer),
  __reducerSchema("admin_set_org_storage_limit", AdminSetOrgStorageLimitReducer),
  __reducerSchema("admin_set_org_suspended", AdminSetOrgSuspendedReducer),
  __reducerSchema("admin_set_superadmin", AdminSetSuperadminReducer),
  __reducerSchema("admin_set_user_suspended", AdminSetUserSuspendedReducer),
  __reducerSchema("admin_set_worker_disabled", AdminSetWorkerDisabledReducer),
  __reducerSchema("admin_set_worker_scaling", AdminSetWorkerScalingReducer),
  __reducerSchema("apply_edits", ApplyEditsReducer),
  __reducerSchema("cancel_job", CancelJobReducer),
  __reducerSchema("cancel_replace_asset", CancelReplaceAssetReducer),
  __reducerSchema("cancel_review", CancelReviewReducer),
  __reducerSchema("cancel_upload", CancelUploadReducer),
  __reducerSchema("create_animation_preset", CreateAnimationPresetReducer),
  __reducerSchema("create_asset", CreateAssetReducer),
  __reducerSchema("create_asset_review_link", CreateAssetReviewLinkReducer),
  __reducerSchema("create_color_palette", CreateColorPaletteReducer),
  __reducerSchema("create_folder", CreateFolderReducer),
  __reducerSchema("create_from_template", CreateFromTemplateReducer),
  __reducerSchema("create_group", CreateGroupReducer),
  __reducerSchema("create_invite", CreateInviteReducer),
  __reducerSchema("create_org", CreateOrgReducer),
  __reducerSchema("create_project", CreateProjectReducer),
  __reducerSchema("create_project_folder", CreateProjectFolderReducer),
  __reducerSchema("create_review_link", CreateReviewLinkReducer),
  __reducerSchema("create_snapshot", CreateSnapshotReducer),
  __reducerSchema("create_space", CreateSpaceReducer),
  __reducerSchema("decline_invite", DeclineInviteReducer),
  __reducerSchema("delete_animation_preset", DeleteAnimationPresetReducer),
  __reducerSchema("delete_asset", DeleteAssetReducer),
  __reducerSchema("delete_color_palette", DeleteColorPaletteReducer),
  __reducerSchema("delete_comment", DeleteCommentReducer),
  __reducerSchema("delete_folder", DeleteFolderReducer),
  __reducerSchema("delete_group", DeleteGroupReducer),
  __reducerSchema("delete_integration", DeleteIntegrationReducer),
  __reducerSchema("delete_job", DeleteJobReducer),
  __reducerSchema("delete_mcp_key", DeleteMcpKeyReducer),
  __reducerSchema("delete_motion_track", DeleteMotionTrackReducer),
  __reducerSchema("delete_notifications", DeleteNotificationsReducer),
  __reducerSchema("delete_org", DeleteOrgReducer),
  __reducerSchema("delete_project", DeleteProjectReducer),
  __reducerSchema("delete_project_folder", DeleteProjectFolderReducer),
  __reducerSchema("delete_review_link", DeleteReviewLinkReducer),
  __reducerSchema("delete_snapshot", DeleteSnapshotReducer),
  __reducerSchema("delete_space", DeleteSpaceReducer),
  __reducerSchema("delete_storage_source", DeleteStorageSourceReducer),
  __reducerSchema("duplicate_project", DuplicateProjectReducer),
  __reducerSchema("duplicate_version", DuplicateVersionReducer),
  __reducerSchema("edit_comment", EditCommentReducer),
  __reducerSchema("import_from_source", ImportFromSourceReducer),
  __reducerSchema("invite_to_target", InviteToTargetReducer),
  __reducerSchema("leave_org", LeaveOrgReducer),
  __reducerSchema("lock_clips", LockClipsReducer),
  __reducerSchema("mark_all_notifications_read", MarkAllNotificationsReadReducer),
  __reducerSchema("mark_notifications_read", MarkNotificationsReadReducer),
  __reducerSchema("move_assets", MoveAssetsReducer),
  __reducerSchema("move_folder", MoveFolderReducer),
  __reducerSchema("move_project", MoveProjectReducer),
  __reducerSchema("move_project_folder", MoveProjectFolderReducer),
  __reducerSchema("org_delete_worker", OrgDeleteWorkerReducer),
  __reducerSchema("org_rename_worker", OrgRenameWorkerReducer),
  __reducerSchema("org_request_worker_update", OrgRequestWorkerUpdateReducer),
  __reducerSchema("org_set_worker_disabled", OrgSetWorkerDisabledReducer),
  __reducerSchema("presence_enter", PresenceEnterReducer),
  __reducerSchema("presence_leave", PresenceLeaveReducer),
  __reducerSchema("presence_update", PresenceUpdateReducer),
  __reducerSchema("remove_member", RemoveMemberReducer),
  __reducerSchema("rename_animation_preset", RenameAnimationPresetReducer),
  __reducerSchema("rename_folder", RenameFolderReducer),
  __reducerSchema("rename_job", RenameJobReducer),
  __reducerSchema("rename_mcp_key", RenameMcpKeyReducer),
  __reducerSchema("rename_org", RenameOrgReducer),
  __reducerSchema("rename_project_folder", RenameProjectFolderReducer),
  __reducerSchema("replace_asset", ReplaceAssetReducer),
  __reducerSchema("reprocess_asset", ReprocessAssetReducer),
  __reducerSchema("request_analysis", RequestAnalysisReducer),
  __reducerSchema("request_batch_export", RequestBatchExportReducer),
  __reducerSchema("request_convert", RequestConvertReducer),
  __reducerSchema("request_export", RequestExportReducer),
  __reducerSchema("request_invoicing", RequestInvoicingReducer),
  __reducerSchema("request_motion_track", RequestMotionTrackReducer),
  __reducerSchema("request_preview", RequestPreviewReducer),
  __reducerSchema("request_review", RequestReviewReducer),
  __reducerSchema("request_split_export", RequestSplitExportReducer),
  __reducerSchema("request_still", RequestStillReducer),
  __reducerSchema("request_voiceover", RequestVoiceoverReducer),
  __reducerSchema("resend_invite", ResendInviteReducer),
  __reducerSchema("resolve_comment", ResolveCommentReducer),
  __reducerSchema("restore_snapshot", RestoreSnapshotReducer),
  __reducerSchema("retry_job", RetryJobReducer),
  __reducerSchema("revoke_invite", RevokeInviteReducer),
  __reducerSchema("set_asset_review_round", SetAssetReviewRoundReducer),
  __reducerSchema("set_grant", SetGrantReducer),
  __reducerSchema("set_group_member", SetGroupMemberReducer),
  __reducerSchema("set_member_role", SetMemberRoleReducer),
  __reducerSchema("set_notification_prefs", SetNotificationPrefsReducer),
  __reducerSchema("set_org_logo", SetOrgLogoReducer),
  __reducerSchema("set_project_color_space", SetProjectColorSpaceReducer),
  __reducerSchema("set_project_logo", SetProjectLogoReducer),
  __reducerSchema("set_project_template", SetProjectTemplateReducer),
  __reducerSchema("set_project_watch", SetProjectWatchReducer),
  __reducerSchema("set_project_working_space", SetProjectWorkingSpaceReducer),
  __reducerSchema("set_restricted", SetRestrictedReducer),
  __reducerSchema("set_review_link_expiry", SetReviewLinkExpiryReducer),
  __reducerSchema("set_review_link_version", SetReviewLinkVersionReducer),
  __reducerSchema("set_sync_leader", SetSyncLeaderReducer),
  __reducerSchema("share_version", ShareVersionReducer),
  __reducerSchema("submit_asset_review", SubmitAssetReviewReducer),
  __reducerSchema("submit_review", SubmitReviewReducer),
  __reducerSchema("svc_add_render_pack", SvcAddRenderPackReducer),
  __reducerSchema("svc_asset_uploaded", SvcAssetUploadedReducer),
  __reducerSchema("svc_audit", SvcAuditReducer),
  __reducerSchema("svc_cancel_upload", SvcCancelUploadReducer),
  __reducerSchema("svc_consume_magic_link", SvcConsumeMagicLinkReducer),
  __reducerSchema("svc_create_magic_link", SvcCreateMagicLinkReducer),
  __reducerSchema("svc_create_mcp_key", SvcCreateMcpKeyReducer),
  __reducerSchema("svc_create_org_worker", SvcCreateOrgWorkerReducer),
  __reducerSchema("svc_create_session", SvcCreateSessionReducer),
  __reducerSchema("svc_create_worker", SvcCreateWorkerReducer),
  __reducerSchema("svc_delete_session", SvcDeleteSessionReducer),
  __reducerSchema("svc_email_failed", SvcEmailFailedReducer),
  __reducerSchema("svc_email_sent", SvcEmailSentReducer),
  __reducerSchema("svc_gc_done", SvcGcDoneReducer),
  __reducerSchema("svc_gc_failed", SvcGcFailedReducer),
  __reducerSchema("svc_integration_sent", SvcIntegrationSentReducer),
  __reducerSchema("svc_mark_linked_missing", SvcMarkLinkedMissingReducer),
  __reducerSchema("svc_replacement_uploaded", SvcReplacementUploadedReducer),
  __reducerSchema("svc_reprocess_asset", SvcReprocessAssetReducer),
  __reducerSchema("svc_request_source_check", SvcRequestSourceCheckReducer),
  __reducerSchema("svc_request_source_listing", SvcRequestSourceListingReducer),
  __reducerSchema("svc_review_comment", SvcReviewCommentReducer),
  __reducerSchema("svc_review_decision", SvcReviewDecisionReducer),
  __reducerSchema("svc_save_integration", SvcSaveIntegrationReducer),
  __reducerSchema("svc_save_storage_source", SvcSaveStorageSourceReducer),
  __reducerSchema("svc_set_module_build", SvcSetModuleBuildReducer),
  __reducerSchema("svc_set_org_billing", SvcSetOrgBillingReducer),
  __reducerSchema("svc_set_review_link_password", SvcSetReviewLinkPasswordReducer),
  __reducerSchema("svc_set_source_error", SvcSetSourceErrorReducer),
  __reducerSchema("svc_set_stripe_customer", SvcSetStripeCustomerReducer),
  __reducerSchema("svc_source_audit", SvcSourceAuditReducer),
  __reducerSchema("svc_touch_mcp_key", SvcTouchMcpKeyReducer),
  __reducerSchema("svc_touch_session", SvcTouchSessionReducer),
  __reducerSchema("svc_unsubscribe_email", SvcUnsubscribeEmailReducer),
  __reducerSchema("svc_upgrade_integrations", SvcUpgradeIntegrationsReducer),
  __reducerSchema("svc_upsert_user", SvcUpsertUserReducer),
  __reducerSchema("svc_worker_scaling_status", SvcWorkerScalingStatusReducer),
  __reducerSchema("update_asset", UpdateAssetReducer),
  __reducerSchema("update_color_palette", UpdateColorPaletteReducer),
  __reducerSchema("update_group", UpdateGroupReducer),
  __reducerSchema("update_profile", UpdateProfileReducer),
  __reducerSchema("update_project", UpdateProjectReducer),
  __reducerSchema("update_review_link", UpdateReviewLinkReducer),
  __reducerSchema("update_space", UpdateSpaceReducer),
  __reducerSchema("worker_claim", WorkerClaimReducer),
  __reducerSchema("worker_complete_analysis", WorkerCompleteAnalysisReducer),
  __reducerSchema("worker_complete_media", WorkerCompleteMediaReducer),
  __reducerSchema("worker_complete_render", WorkerCompleteRenderReducer),
  __reducerSchema("worker_complete_track", WorkerCompleteTrackReducer),
  __reducerSchema("worker_fail", WorkerFailReducer),
  __reducerSchema("worker_heartbeat", WorkerHeartbeatReducer),
  __reducerSchema("worker_hello", WorkerHelloReducer),
  __reducerSchema("worker_linked_missing", WorkerLinkedMissingReducer),
  __reducerSchema("worker_progress", WorkerProgressReducer),
  __reducerSchema("worker_set_source_roots", WorkerSetSourceRootsReducer),
  __reducerSchema("worker_source_listed", WorkerSourceListedReducer),
  __reducerSchema("worker_update_result", WorkerUpdateResultReducer),
  __reducerSchema("worker_voiceover_uploaded", WorkerVoiceoverUploadedReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.12.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

